import { TableCompData } from "../../../../components";
import {
  SettingCompanyPrefixHeader,
  ViewStaffData,
} from "../../../../utils/TableHeader";
import { PageTitle } from "../../modules/PageHeaders";
import PrefixEmptyState from "./PrefixEmptyState";

export default function AllCompanyPrefix({
  TableDropDown,
  onSubmit,
  tableHeader,
  tableData,
  emptyMessage,
  btnText,
  marginBottom,
  isFetching,
}) {
  // Check if prefix exists - handle both array and single object responses
  const hasPrefix = tableData && (
    (Array.isArray(tableData) && tableData.length > 0) ||
    (!Array.isArray(tableData) && tableData && Object.keys(tableData).length > 0)
  );
  
  // Convert single object to array for table display if needed
  const displayData = hasPrefix 
    ? (Array.isArray(tableData) ? tableData : [tableData])
    : [];
  
  return (
    <div>
      <div className="mb-4">
        <PageTitle title={"Cooperative Prefix"} />
      </div>
      
      {isFetching ? (
        <div className="py-4 text-center">
          <h3>Loading...</h3>
        </div>
      ) : hasPrefix ? (
        <div className="mb-5">
          <TableCompData
            columns={
              tableHeader
                ? tableHeader
                : SettingCompanyPrefixHeader(TableDropDown)
            }
            data={displayData}
            marginBottom={marginBottom}
          />
        </div>
      ) : (
        <PrefixEmptyState onSetPrefix={onSubmit} />
      )}
    </div>
  );
}
